import { render, staticRenderFns } from "./NotesEditorModal.vue?vue&type=template&id=2288495e"
import script from "./NotesEditorModal.vue?vue&type=script&lang=js"
export * from "./NotesEditorModal.vue?vue&type=script&lang=js"
import style0 from "./NotesEditorModal.vue?vue&type=style&index=0&id=2288495e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports